import "src/decidim/alternative_landing/alternative_landing.js";
require.context("../images", true);
import "entrypoints/decidim_alternative_landing.scss";
